import { type FC, type JSX, useMemo } from 'react'
import { useRange, type UseRefinementListProps } from 'react-instantsearch'

import {
  ProductSearchRefinement,
  ProductSearchRefinementContext,
} from '../ProductSearchRefinement'
import { useProductSearchRefinementLabel } from '../useProductSearchRefinementLabel'

import { ProductSearchRefinementDiscountListbox } from './ProductSearchRefinementDiscountListbox'

const PRODUCT_SEARCH_REFINEMENT_PRICE_RANGE_COUNT = 1

type ProductSearchRefinementDiscountRangeProps = Pick<
  UseRefinementListProps,
  'attribute'
> & {
  hidden: boolean
}

export const ProductSearchRefinementDiscountRange: FC<
  ProductSearchRefinementDiscountRangeProps
> = ({ attribute, hidden }) => {
  const formLabel = useProductSearchRefinementLabel(attribute)

  const refinementRange = useRange({ attribute })

  const { canRefine, start } = refinementRange

  const contextValue = useMemo(
    () => ({
      refinementRange,
      refinementRangeOptions: {
        attribute,
      },
    }),
    [attribute, refinementRange],
  )

  if (hidden || !canRefine) {
    return null
  }

  const renderValue = (): JSX.Element => (
    <>
      <span className="truncate">{formLabel}</span>
      {start.some((item) => Number.isFinite(item)) && (
        <span className="text-dark-primary-strong">
          {PRODUCT_SEARCH_REFINEMENT_PRICE_RANGE_COUNT}
        </span>
      )}
    </>
  )

  return (
    <div>
      <ProductSearchRefinementContext value={contextValue}>
        <ProductSearchRefinement
          attribute={attribute}
          renderValue={renderValue}
          slotProps={{
            listbox: {
              title: formLabel,
            },
          }}
          slots={{
            listbox: ProductSearchRefinementDiscountListbox,
          }}
        />
      </ProductSearchRefinementContext>
    </div>
  )
}
